import { useQuery } from '@tanstack/react-query'
import { getCurrentOrganization } from '@/api/services/organization.service'
import { useAuthStore } from '@/stores/useAuthStore'

export const organizationQueryKeys = {
  current: ['organization', 'current'] as const,
}

export function useCurrentOrganization() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  return useQuery({
    queryKey: organizationQueryKeys.current,
    queryFn: getCurrentOrganization,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: isAuthenticated,
  })
}
